// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMCard.tsx — PropelMapper content card + eyebrow header.
//
// The web content primitive: a soft white surface (--pm-surface,
// --pm-border-card, --pm-shadow-card, radius-xl) holding any content. An optional
// eyebrow header gives the recurring pattern from every dashboard: an UPPERCASE
// section label, an optional leading icon + count pill, and an optional
// right-aligned action link. All --pm-* tokens; themes light/dark automatically.

const PMCARD_CSS = `
.pmcard{box-sizing:border-box;position:relative;background:var(--pm-surface);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-card);padding:20px 22px}
.pmcard *{box-sizing:border-box}
.pmcard-eyebrow{display:flex;align-items:center;gap:8px;margin:0 0 14px;font:var(--pm-section);font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--pm-fg-1)}
.pmcard-eyebrow-ic{display:inline-flex;flex:0 0 auto;line-height:0;width:17px;height:17px;color:var(--pm-primary)}
.pmcard-eyebrow-ic svg{width:100%;height:100%;display:block}
.pmcard-count{font:var(--pm-pill);background:var(--pm-surface-variant);color:var(--pm-fg-2);border-radius:var(--pm-radius-pill,999px);padding:2px 8px}
.pmcard-act{margin-left:auto;display:inline-flex;align-items:center;gap:3px;font-size:12px;font-weight:600;color:var(--pm-primary);text-transform:none;letter-spacing:0;cursor:pointer;background:none;border:none;font-family:inherit;text-decoration:none}
.pmcard-act:hover{color:var(--pm-primary-dark);text-decoration:underline}
.pmcard-act-ic{display:inline-flex;line-height:0;width:15px;height:15px}
.pmcard-act-ic svg{width:100%;height:100%;display:block}
`;

function pmcardEnsureCSS() {
  if (typeof document === "undefined") return;
  if (document.getElementById("pmcard-css")) return;
  const s = document.createElement("style");
  s.id = "pmcard-css";
  s.textContent = PMCARD_CSS;
  document.head.appendChild(s);
}

function pmcardIcon(base, size, cls) {
  if (!base) return null;
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = I[base + "-outline"] ? base + "-outline" : (I[base] ? base : null);
  const vars = { "--icon-fg": "currentColor", "--icon-accent": "currentColor", "--icon-accent-2": "currentColor", "--icon-accent-3": "currentColor" };
  if (name && I[name]) {
    return <span className={cls} aria-hidden="true"
      style={{ width: size, height: size, ...vars }}
      dangerouslySetInnerHTML={{ __html: I[name] }} />;
  }
  return <span className={"material-symbols-outlined " + cls} aria-hidden="true"
    style={{ fontSize: size, lineHeight: 0, width: "auto", height: "auto" }}>{base}</span>;
}

export function PMCard({
  eyebrow,
  icon,
  count,
  action,
  className = "",
  style = {},
  children,
  ...rest
}) {
  pmcardEnsureCSS();
  const hasHeader = eyebrow != null || icon != null || count != null || action != null;
  return (
    <section className={"pmcard" + (className ? " " + className : "")} style={style} {...rest}>
      {hasHeader ? (
        <div className="pmcard-eyebrow">
          {icon ? pmcardIcon(icon, 17, "pmcard-eyebrow-ic") : null}
          {eyebrow != null ? <span>{eyebrow}</span> : null}
          {count != null ? <span className="pmcard-count">{count}</span> : null}
          {action ? (
            <button type="button" className="pmcard-act" onClick={action.onClick}>
              <span>{action.label}</span>
              {pmcardIcon(action.icon || "chevron_right", 15, "pmcard-act-ic")}
            </button>
          ) : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
